import * as React from 'react';
import { History } from 'history';
import { IState as FieldsState } from './Fields';
import * as IDatabase from '../../../types/database';

import './styles.css';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

export interface IState {
    options: IDatabase.IField[];
    selected: IDatabase.IField[];
}
interface IProps {
    handleSave: (state: IState) => void;
    getSavedSession: () => Promise<{ search: IState; fields: FieldsState } | null>;
    history: History;
    renderNextStepLink: (onClick: () => boolean) => any;
    handleCancel: () => void;
}
export default class Search extends React.Component<IProps, IState> {
    state = {
        selected: [],
        options: [],
    };

    async componentDidMount() {
        const session = await this.props.getSavedSession();
        const searchState: IState = this.state;
        if (
            session &&
            session.fields &&
            session.fields &&
            session.fields.selected &&
            session.fields.selected &&
            Array.isArray(session.fields.selected)
        ) {
            session.fields.selected.forEach(x => {
                x.fields.filter(w => w.predefined).forEach(y => {
                    if (session && session.search) {
                        // Only include fields that have not alread been selected from pervious sessions
                        if (session.search.selected.findIndex(z => z.id === y.id) === -1) {
                            y.group = x.name;
                            searchState.options.push(y);
                        }
                    } else {
                        y.group = x.name;
                        searchState.options.push(y);
                    }
                });
            });
        }
        if (session && session.search) {
            searchState.selected = session.search.selected.filter(w => w.predefined);
        }
        this.setState({
            ...searchState,
        });
    }

    handleGoBack = () => {
        this.props.history.goBack();
    };

    handleSave = (): boolean => {
        this.props.handleSave({ ...this.state });
        return true;
    };

    handleSelected = (index: number, item: IDatabase.IField) => {
        window.onbeforeunload = () => {
            return true;
        };
        const options: IDatabase.IField[] = [...this.state.options];
        const selected: IDatabase.IField[] = [...this.state.selected];

        if (options.findIndex(x => x.name === item.name) !== -1 && selected.indexOf(item) === -1) {
            options.splice(index, 1);
            selected.push(item);
        } else if (selected.indexOf(item) !== -1) {
            selected.splice(index, 1);
            options.unshift(item);
        }

        this.setState({ options, selected });
    };

    handleSelectAll = () => {
        window.onbeforeunload = () => {
            return true;
        };
        const selected = [...this.state.selected, ...this.state.options];
        const options: IDatabase.IField[] = [];
        this.setState({ selected, options });
    };

    handleUnselectAll = () => {
        window.onbeforeunload = () => {
            return true;
        };
        const options = [...this.state.selected, ...this.state.options];
        const selected: IDatabase.IField[] = [];
        this.setState({ selected, options });
    };

    renderSelectedItem = (item: IDatabase.IField, index: number) => {
        return (
            <li key={`section-${index}`}>
                <span className="p-3" onClick={() => this.handleSelected(index, item)}>
                    {item.group || ''} - {item.label}
                </span>
            </li>
        );
    };

    render() {
        return (
            <div>
                <div className="row px-2">
                    <h5><FormattedMessage id="db.search.hdr" defaultMessage="3. Search Filters" /></h5>
                </div>
                <div className="row text-muted px-2 py-3">
                    <FormattedHTMLMessage id="db.search.txt" defaultMessage={`
                    <p>Search filters allow users to narrow down results when searching
                    a database, helping them to quickly find the information they are looking
                    for.<br/> 
                    Please select the fields that will serve as search filters from those you have 
                    selected for your database. 
                    Make sure that the search filters match the information that is most important to
                    your users.</p>
                    `} />
                </div>
                <div className="row">
                    <div className="col-5">
                        <div className="filterBox dbFieldLt">
                            <h4><FormattedMessage id="db.search.available" defaultMessage="Available Search Filters" /> ({this.state.options.length})</h4>
                            <ul>{this.state.options.map(this.renderSelectedItem)}</ul>
                        </div>
                    </div>
                    <div className="col-2 d-flex flex-column align-items-center justify-content-center">
                        <button
                            className="harmonize m-3 px-3 py-1 align-self-center"
                            onClick={this.handleSelectAll}>
                            <i className="fas fa-angle-right" />
                        </button>
                        <button
                            className="harmonize m-3 px-3 py-1 align-self-center"
                            onClick={this.handleUnselectAll}>
                            <i className="fas fa-angle-left" />
                        </button>
                    </div>
                    <div className="col-5">
                        <div className="filterBox dbFieldLt">
                            <h4><FormattedMessage id="db.search.selected" defaultMessage="Selected Search Filters" /> ({this.state.selected.length})</h4>
                            <ul>{this.state.selected.map(this.renderSelectedItem)}</ul>
                        </div>
                    </div>
                </div>
                <div className="row border-top mt-5">
                    {this.props.renderNextStepLink(this.handleSave)}
                    <button className="primary-inv" onClick={this.handleGoBack}>
                        <FormattedMessage id="db.search.back" defaultMessage="Back" />
                    </button>
                    <button className="btn btn-link" onClick={this.props.handleCancel}><FormattedMessage id="db.search.cancel" defaultMessage="Cancel" /></button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/client/database/setup/Search.tsx